export default "__VITE_ASSET__09kaOcN5__"